import { render, staticRenderFns } from "./OverviewMap.vue?vue&type=template&id=83fb3650&scoped=true&"
import script from "./OverviewMap.vue?vue&type=script&lang=ts&"
export * from "./OverviewMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fb3650",
  null
  
)

export default component.exports